import { CounterPageMessages } from '../types';

export const counterPageCA: CounterPageMessages = {
  'app.counter.counter': '(CA) Counter',
  'app.counter.double.counter': '(CA) Double Counter',
}
